import { AbstractJSONModel } from "./master-model";

export interface ISalaryTypePost {
  code: number;
  name: string;
  account_no: string | null;
  is_hidden: boolean;
  is_system_defined: boolean;
  institution_id: number;
  created_at: Date;
  updated_at: Date;
}

export interface ISalaryTypePut {
  id: number;
  code: number;
  name: string;
  account_no: string | null;
  is_hidden: boolean;
}

export interface ISalaryType {
  id: number;
  code: number;
  name: string;
  account_no: string | null;
  is_hidden: boolean;
  is_system_defined: boolean;
  institution_id: number;
  created_at: Date;
  updated_at: Date;
}

export class SalaryType extends AbstractJSONModel implements ISalaryType {
  public id = -1;
  public code = -1;
  public name = "";
  public account_no: string | null = null;
  public is_hidden = false;
  public is_system_defined = false;
  public institution_id = -1;
  public created_at: Date = new Date();
  public updated_at: Date = new Date();

  public convertToPostObject(): ISalaryTypePost {
    const s: ISalaryTypePost = Object.assign({});
    s.code = this.code;
    s.name = this.name;
    s.account_no = this.account_no;
    s.is_hidden = this.is_hidden;
    s.is_system_defined = this.is_system_defined;
    s.institution_id = this.institution_id;
    s.created_at = this.created_at;
    s.updated_at = this.updated_at;

    return s;
  }

  public convertToPutObject(): ISalaryTypePut {
    const s: ISalaryTypePut = Object.assign({});
    s.id = this.id;
    s.code = this.code;
    s.name = this.name;
    s.account_no = this.account_no;
    s.is_hidden = this.is_hidden;
    return s;
  }

  equals(other: ISalaryType): boolean {
    return other.id === this.id;
  }
}
